export enum PaymentMethod {
  Cash = 1,
  Cheque = 2,
  CreditCard = 3,
  StandingOrder = 4,
  AccountTransfer = 5,
  DirectDebit = 6,
}

export enum PaymentExportFormat {
  Generic = 0,
  BankLineV1 = 1,
  HSBCHex4w = 2,
  BankLineV2 = 3,
  BankLineV2Bulk = 4,
  LloydsTelePay = 5,
  SEPA1_0 = 6,
  BarclaysSIFPegasusOpera = 7,
  SEPA1_1 = 8,
  Santander = 9,
  BankOfIreland = 10,
  LloydsFasterPayments = 11,
  LloydsBACS = 12,
  CouttsCoFasterPayments = 13,
  MetroBank = 14,
  Handelsbanken = 15,
  Virgin = 16,
  SEPA_ISO20022 = 17,
}
